import * as React from 'react';

export type TNewbuildingPurchaseGiftPromoSource = 'banner' | 'header';

export interface INewbuildingPurchaseGiftPromoContext {
  /** Точки входа акции можно показывать: тогл, конфиг, регион и группа эксперимента */
  isAvailable: boolean;
  openModal(source: TNewbuildingPurchaseGiftPromoSource): void;
}

export const NewbuildingPurchaseGiftPromoContext = React.createContext<INewbuildingPurchaseGiftPromoContext>({
  isAvailable: false,
  openModal: () => {},
});

export function useNewbuildingPurchaseGiftPromo(): INewbuildingPurchaseGiftPromoContext {
  return React.useContext(NewbuildingPurchaseGiftPromoContext);
}
